@use "../../styles/breakpoint.module.scss" as *;

.root {
    visibility: inherit;
}

.inner {
    display: flex;
    justify-content: space-between;
    align-items: flex-end;
    grid-gap: var(--spacer-24);
    margin-bottom: var(--spacer-40);
    padding-bottom: var(--spacer-24);
    border-bottom: 1px solid var(--color-contrast);

    @media ($below-mobile) {
        flex-direction: column;
        align-items: flex-start;
    }
}

.clickable {
    flex-shrink: 0;

    // A little hacky, this is compensating for the difference between
    // heading baseline and its actual bottom
    @media ($above-mobile) {
        margin-bottom: 10px;
    }
}
